import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchReviews } from "src/redux/slices/reviews";
import PageHero from "src/sections/components/page-hero";
import Review from "src/sections/reviews/components/review";
import ReviewsCarousel from "src/sections/reviews/reviews-carousel";
import TouristsCarousel from "src/sections/components/tourists-carousel";
import { usePageMeta } from "src/utils/seo";
import Footer from "../../components/footer/footer";

// Страница со всеми отзывами: новые сверху.
const AllReviews = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  usePageMeta({
    title: t("allReviews.title"),
    description: t("allReviews.subtitle"),
  });

  // Только общие: отзывы о конкретном туре показываются на его странице.
  const reviews = useSelector((state) =>
    state.reviews.reviews.items.filter((review) => !review.activityId)
  );

  useEffect(() => {
    dispatch(fetchReviews());
  }, [dispatch]);

  // В колонку идут только отзывы, написанные словами. Отзыв-скриншот целиком
  // состоит из картинки, и два десятка таких картинок друг под другом — это
  // экраны бесконечной прокрутки; их место в карусели внизу, где кадр
  // открывается на весь экран по клику.
  const written = reviews.filter((review) => review.comment?.trim());
  const list = [...written].reverse();
  const hasPhotos = reviews.some((review) => (review.photos || []).length > 0);

  return (
    <div className="min-h-screen w-full flex flex-col justify-between bg-kj-dark text-kj-ink">
      <PageHero
        eyebrow={t("allReviews.eyebrow")}
        title={t("allReviews.title")}
        subtitle={t("allReviews.subtitle")}
      />

      <div className="max-w-3xl w-full mx-auto px-4 mt-10 sm:mt-14 mb-12">
        <button
          type="button"
          onClick={() => navigate("/write-review")}
          className="w-full sm:w-auto rounded-md border border-kj-gold px-5 py-2.5 text-xs sm:text-sm font-bold uppercase tracking-[0.12em] text-kj-gold hover:bg-kj-gold hover:text-kj-dark transition-colors"
        >
          {t("reviews.btnText")}
        </button>

        {list.length > 0 ? (
          <div className="divide-y divide-kj-line">
            {list.map((review) => (
              <Review
                key={review._id}
                name={review.name}
                date={review.date}
                stars={review.stars}
                comment={review.comment}
                photos={review.photos}
              />
            ))}
          </div>
        ) : (
          // Пусто — только когда отзывов нет совсем: если все они пришли
          // картинками, страница не пустая, они ниже в карусели.
          !hasPhotos && (
            <p className="mt-10 text-base text-kj-sub leading-relaxed">
              {t("allReviews.empty")}
            </p>
          )
        )}
      </div>

      {/* Лента фотографий из отзывов — шире колонки с текстом, поэтому стоит
          вне неё, в самом низу. Отзывы сюда уже загружены страницей, второй
          запрос из карусели только очистил бы список на время загрузки. */}
      <div className="max-w-[1526px] w-full mx-auto px-4 mb-14 flex flex-col gap-y-12 sm:gap-y-16">
        <TouristsCarousel />
        <ReviewsCarousel fetchOnMount={false} />
      </div>

      <Footer />
    </div>
  );
};

export default AllReviews;
